'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import emAction from '../../actions/emAction';
import emStore from '../../stores/emStore';
import userStore from '../../stores/userStore';
import genFunction from '../../functions/genFunction';

class EstateFilter extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePrint = this.handlePrint.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.state = {
            processing: emStore.getState().processing,
            warningMsg: emStore.getState().warningMsg,
            iniYear: 2017,
            iniMonth: 11,
            staffId: emStore.getState().staffId,
            mcst: emStore.getState().mcst,
            selectedYear: emStore.getState().selectedYear,
            selectedMonth: emStore.getState().selectedMonth,

            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId,
        }
    }
    static defaultProps = {
        mthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };
    componentDidMount() {
        emStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
    }
    componentWillUnmount() {
        emStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
    }
    onUserChange(state) {
        this.setState({ 
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId 
        });
    }
    onChange(state) {
        this.setState({
            processing: state.processing,
            selectedYear: state.selectedYear,
            selectedMonth: state.selectedMonth,
            staffId: state.staffId,
            mcst: state.mcst,
            warningMsg: state.warningMsg,
        })
    }
    handleChange(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        let value = e.target.value.split(":");
        let selectedYear = parseInt(value[0]);
        let selectedMonth = parseInt(value[1]);
        if (index == 2) {
            emAction.selectMonth({ selectedYear: selectedYear, selectedMonth: selectedMonth });
        } else if (index == 1) {
            emAction.mcst({ mcst: value[0] });
        }else{
            emAction.staffId({ staffId: value[0] });
        }
    }

    handleSubmit() {
        /*
        if(this.state.staffId == -1 && this.state.mcst == "" ){
            return emAction.warningMsg("Please select either staff name or condo name");
        }
        */
        if(this.state.processing) return;

        emAction.warningMsg("");
        emAction.processing(true);
        emAction.getEstate(this.state.staffId, this.state.mcst, this.state.selectedYear, this.state.selectedMonth);
    }
    handlePrint(){
        window.print();
    }
    handleExport(){
        /*
        if(this.state.staffId == -1 || this.state.mcst == "" ){
            return emAction.warningMsg("Please select either staff name or condo name");
        }
        */
        if(this.state.processing) return;

        emAction.warningMsg("");
        emAction.processing(true);
        emAction.exportEstate(this.state.staffId, this.state.mcst, this.state.selectedYear, this.state.selectedMonth);

    }
    renderStaffs() {
        let staffs = this.props.staffs;
        if (staffs.length > 0) {
            staffs = this.props.staffs.filter((staff) => {
                return (genFunction.hasPermission(this.state.permission, 11) ||
                    genFunction.isSubordinate(this.state.subordinate, staff.staffId) ||
                    genFunction.isUser(this.state.userId, staff.staffId) || 
                    genFunction.isMember(this.props.teamMember, staff.staffId)
                );
            });

            return staffs.map((staff, index) => {
                return (
                    this.renderStaff(staff, index)
                );
            });
        }
    }
    renderCondos(){
        let condos = this.props.condos;
        if (condos.length > 0) {
            condos = condos.filter((condo) => {
                return (genFunction.hasPermission(this.state.permission, 11) ||
                    genFunction.hasCondo(this.props.teamCondo, condo.mcst)
                );
            });

            return condos.map((condo, index) => {
                return (
                    <option value={condo.mcst} key={index}>{condo.condoName}</option>
                );
            });
        }
        
    }
    renderStaff(staff, index) {
        return (<option value={staff.staffId} key={index}>{staff.userName}</option>);
    }
    renderOption(yr, mth) {
        let isSelected = yr == this.props.selectedYear && mth == this.props.selectedMonth ? true : false;
        return (<option value={yr + ":" + mth} key={yr + mth}>{this.props.mthTxt[mth] + " " + yr}</option>);
    }
    renderOptions() {
        let options = [];
        let thisYear = new Date().getFullYear();
        let thisMonth = new Date().getMonth();

        for (let yr = thisYear; yr >= this.state.iniYear; yr--) {
            if (thisYear == this.state.iniYear) {
                for (let mth = thisMonth; mth >= this.state.iniMonth; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            } else if (yr == thisYear) {
                for (let mth = thisMonth; mth >= 0; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            } else if (yr == this.state.iniYear) {
                for (let mth = 11; mth >= this.state.iniMonth; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            } else {
                for (let mth = 11; mth >= 0; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            }

        }
        return options;
    }
    render() {


        return (
            <div className="atd-i">
                <div className="row">
                    <div className="col-md-5 col-lg-3">
                        <form className="form-horizontal atd-i-wp">
                            <label htmlFor="staffName" className="col-xs-4 control-label">Staff Name: </label>
                            <div className="input-group input-group-sm">
                                <select className="form-control atd-sel" id="staffName" name="staffName" data-index="0" onChange={this.handleChange} defaultValue={this.state.staffId}>
                                    <option value="" >Any Staff</option>
                                    {this.renderStaffs()}
                                </select>
                            </div>
                        </form>
                        <form className="form-horizontal atd-i-wp">
                            <label htmlFor="condoName" className="col-xs-4 control-label">Condo Name: </label>
                            <div className="input-group input-group-sm">
                                <select className="form-control atd-sel" id="condoName" name="condoName" data-index="1" onChange={this.handleChange} defaultValue={this.state.mcst}>
                                    <option value="" >Any Condo</option>
                                    {this.renderCondos()}
                                </select>
                            </div>
                        </form>
                        <div className="warning">{this.state.warningMsg}</div>
                    </div>
                    <div className="col-md-5 col-lg-3">
                        <form className="form-horizontal atd-i-wp">
                            <label htmlFor="month" className="col-xs-4 control-label">Select Month: </label>
                            <div className="input-group input-group-sm">
                                <select className="form-control atd-sel" id="month" name="month" data-index="2" onChange={this.handleChange} defaultValue={this.state.startYear + ":" + this.state.startMonth}>
                                    {this.renderOptions()}
                                </select>
                            </div>
                        </form>
                        <div className="atd-0-tp atd-i-btn">
                            <button className="btn btn-default btn-sm" type="button" onClick={this.handleSubmit}>Search</button>
                        </div>
                        <div className="atd-0-tp atd-i-btn">
                            <button className="btn btn-primary btn-sm" onClick={this.handleExport}>Export</button>
                        </div>
                        <div className="atd-0-tp atd-i-btn">
                            <button className="btn btn-primary btn-sm" onClick={this.handlePrint}>Print</button>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default EstateFilter;


// WEBPACK FOOTER //
// ./app/components/emComponents/estateFilter.js